// Social Links Configuration
// Update these with your actual social media links
// Set url to null or remove the entry to hide a social link

export const socialLinks = {
  github: {
    url: "https://github.com/ja-yy",
    label: "GitHub",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/ja-yy-patel/",
    label: "LinkedIn",
  },
  twitter: {
    url: "https://x.com/j_a__y",
    label: "X",
  },
  upwork: {
    url: "https://www.upwork.com/freelancers/~011da67768e6af151f",
    label: "Upwork",
  },
  youtube: {
    url: null, // Set to your YouTube channel URL or null to hide
    label: "YouTube",
  },
};

// Email for contact
export const email = "jayypatel.work@gmail.com";
